"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _BucketLifecycleConfiguration_1 = require("./_BucketLifecycleConfiguration");
exports.PutBucketLifecycleConfigurationInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        LifecycleConfiguration: {
            shape: _BucketLifecycleConfiguration_1._BucketLifecycleConfiguration,
            locationName: "LifecycleConfiguration",
            xmlNamespace: {
                uri: "http://s3.amazonaws.com/doc/2006-03-01/"
            }
        }
    },
    payload: "LifecycleConfiguration"
};
//# sourceMappingURL=PutBucketLifecycleConfigurationInput.js.map